// See https://chakra-ui.com/community/recipes/floating-labels

const activeLabelStyles = {
  transform: 'scale(0.7) translateY(-12px)',
};

export const Form = {
  variants: {
    floating: {
      container: {
        _focusWithin: {
          label: {
            ...activeLabelStyles,
          },
        },
        'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label':
          {
            ...activeLabelStyles,
          },
        input: {
          height: 12,
          pt: 5,
          pb: 2,
        },
        label: {
          top: 0,
          left: 0,
          zIndex: 2,
          position: 'absolute',
          pointerEvents: 'none',
          mx: 3,
          px: 1,
          my: 3,
          transformOrigin: 'left top',
        },
      },
    },
  },
};
